import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { proposalService } from '../services/api';

export default function ProposalsPage() {
  const [proposals, setProposals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadProposals();
  }, []);

  const loadProposals = async () => {
    try {
      const data = await proposalService.getAll();
      setProposals(data);
    } catch (error) {
      console.error('Error loading proposals:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      draft: 'badge-gray',
      pending: 'badge-warning',
      accepted: 'badge-success',
      declined: 'badge-danger',
    };
    return badges[status] || 'badge-gray';
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Proposals | CR Hood Admin</title>
      </Helmet>

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">Proposals</h1>
          <Link to="/proposals/new" className="btn btn-primary">New Proposal</Link>
        </div>

        <div className="card p-0 overflow-hidden">
          {proposals.length === 0 ? (
            <div className="text-center py-12">
              <p className="text-gray-500">No proposals yet</p>
              <Link to="/proposals/new" className="text-accent hover:underline text-sm mt-1 inline-block">
                Create your first proposal
              </Link>
            </div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Title</th>
                    <th>Client</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {proposals.map((proposal) => (
                    <tr key={proposal.id}>
                      <td className="font-medium">{proposal.title}</td>
                      <td>{proposal.client?.name || '-'}</td>
                      <td>${proposal.amount?.toLocaleString() || '0'}</td>
                      <td>
                        <span className={`badge ${getStatusBadge(proposal.status)}`}>
                          {proposal.status}
                        </span>
                      </td>
                      <td>{new Date(proposal.createdAt).toLocaleDateString()}</td>
                      <td>
                        <Link
                          to={`/proposals/${proposal.id}`}
                          className="text-accent hover:underline text-sm"
                        >
                          Edit
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
